import {
    Menu,
    MenuItem,
    ProSidebarProvider,
    Sidebar,
    SubMenu,
} from "react-pro-sidebar";
import { Link, useNavigate } from "react-router-dom";
import dashboard from "../../assets/images/icon1.svg";
import template from "../../assets/images/icon5.svg";
import team from "../../assets/images/icon3.svg";
import report from "../../assets/images/icon8.svg";
import folderIcon from "../../assets/images/sidebarFolderIcon.svg";
import entity from "../../assets/images/icon9.svg";

import { useState } from "react";
import { useDispatch } from "react-redux";
import { setRoute } from "../../redux/route/routeSlice";
import schedule from "../../assets/images/scheduler.svg";
import announcement from "../../assets/images/icon6.svg";
import activityLog from "../../assets/images/activityLog.svg";
import bell from "../../assets/images/bell.svg";
import productList from "../../assets/images/productList.svg";
import { useSelector } from "react-redux";
import { useEffect } from "react";

export default function RmLeadSidebar(props) {
    const [activePage, setActivePage] = useState(null);
    const [dropdown, setDropdown] = useState();
    const navigation = useNavigate();
    const dispatch = useDispatch();
    const reduxData = useSelector((state) => state);

    function handleActive(event, heading) {
        let activeA = document.querySelector("a.active");
        if (activeA) {
            activeA.classList.remove("active");
        }

        dispatch(setRoute(heading));
        if (!event.target.classList.value.includes("active")) {
            event.target.classList.toggle("active");
            if (activePage) activePage.classList.remove("active");
            setActivePage(event.target);
        }
    }

    const leadLink = () => {
        let activeSpan = document.querySelector("span.active");
        if (activeSpan) {
            activeSpan.classList.remove("active");
        }
        setDropdown(dropdown === "Leads" ? null : "Leads");
        dispatch(setRoute("Leads"));
        navigation("/rm-lead/leads/all");
    };

    const checkTeamLead = () => {
        let found;
        let id = reduxData?.auth?.user?._id;
        reduxData?.allTeams?.value?.teams?.forEach((element) => {
            element?.members?.forEach((e) => {
                if (e?._id === id) {
                    found = element;
                }
            });
        });

        if (found && found?.teamLead?._id === id) {
            return true;
        } else {
            return false;
        }
    };

    const getFolderName = () => {
        if (reduxData?.folders?.folderStructure?.length) {
            let name = reduxData?.folders?.folderStructure[0]?.name;
            return name;
        }
    };

    useEffect(() => {
        if (reduxData?.heading?.value?.includes("Cases")) {
            setDropdown("Cases");
        } else if (reduxData?.heading?.value?.includes("Leads")) {
            setDropdown("Leads");
        }
    }, [reduxData?.heading?.value]);

    return (
        <ProSidebarProvider>
            <Sidebar>
                <Menu>
                    <MenuItem
                        onClick={(e) => {
                            handleActive(e, "Dashboard");
                            setDropdown(null);
                        }}
                        routerLink={
                            <Link onClick={props.menuClick} to="/rm-lead" />
                        }
                    >
                        <img src={dashboard} alt="dashboard" /> Dashboard
                    </MenuItem>

                    {checkTeamLead() && (
                        <MenuItem
                            onClick={(e) => {
                                handleActive(e, "Team");
                                setDropdown(null);
                            }}
                            routerLink={
                                <Link
                                    onClick={props.menuClick}
                                    to="/rm-lead/team"
                                />
                            }
                        >
                            <img src={team} alt="team" /> Team
                        </MenuItem>
                    )}
                    <SubMenu
                        icon={<img src={template} alt="setting" />}
                        className="settings"
                        label="Leads"
                        onClick={leadLink}
                        open={dropdown === "Leads"}
                    >
                        <MenuItem
                            onClick={(e) => {
                                handleActive(e, "Leads");
                            }}
                            routerLink={
                                <Link
                                    onClick={props.menuClick}
                                    to="/rm-lead/leads/all"
                                />
                            }
                        >
                            All Leads
                        </MenuItem>
                        <MenuItem
                            onClick={(e) => {
                                handleActive(e, "Leads");
                            }}
                            routerLink={
                                <Link
                                    onClick={props.menuClick}
                                    to="/rm-lead/leads/assigned"
                                />
                            }
                        >
                            Assigned Leads
                        </MenuItem>
                        {checkTeamLead() && (
                            <MenuItem
                                onClick={(e) => {
                                    handleActive(e, "Leads");
                                }}
                                routerLink={
                                    <Link
                                        onClick={props.menuClick}
                                        to="/rm-lead/leads/unassigned"
                                    />
                                }
                            >
                                Unassigned Leads
                            </MenuItem>
                        )}
                        <MenuItem
                            onClick={(e) => {
                                handleActive(e, "Leads");
                            }}
                            routerLink={
                                <Link
                                    onClick={props.menuClick}
                                    to="/rm-lead/leads/own"
                                />
                            }
                        >
                            Own Leads
                        </MenuItem>
                    </SubMenu>
                    <SubMenu
                        icon={<img src={template} alt="setting" />}
                        className="settings"
                        label="Case"
                        onClick={() => {
                            setDropdown(dropdown === "Cases" ? null : "Cases");
                            let activeSpan =
                                document.querySelector("span.active");
                            if (activeSpan) {
                                activeSpan.classList.remove("active");
                            }
                        }}
                        open={dropdown === "Cases"}
                    >
                        <MenuItem
                            onClick={(e) => {
                                handleActive(e, "Cases");
                            }}
                            routerLink={
                                <Link
                                    onClick={props.menuClick}
                                    to="/rm-lead/all-cases"
                                />
                            }
                        >
                            All Case
                        </MenuItem>
                        <MenuItem
                            onClick={(e) => {
                                handleActive(e, "Cases");
                            }}
                            routerLink={
                                <Link
                                    onClick={props.menuClick}
                                    to="/rm-lead/pending-cases"
                                />
                            }
                        >
                            Pending
                        </MenuItem>
                        <MenuItem
                            onClick={(e) => {
                                handleActive(e, "Cases");
                            }}
                            routerLink={
                                <Link
                                    onClick={props.menuClick}
                                    to="/rm-lead/submitted-cases"
                                />
                            }
                        >
                            Submitted
                        </MenuItem>
                        <MenuItem
                            onClick={(e) => {
                                handleActive(e, "Cases");
                            }}
                            routerLink={
                                <Link
                                    onClick={props.menuClick}
                                    to="/rm-lead/processing-cases"
                                />
                            }
                        >
                            Processing
                        </MenuItem>
                        <MenuItem
                            onClick={(e) => {
                                handleActive(e, "Cases");
                            }}
                            routerLink={
                                <Link
                                    onClick={props.menuClick}
                                    to="/rm-lead/rejected-cases"
                                />
                            }
                        >
                            Rejected
                        </MenuItem>
                        <MenuItem
                            onClick={(e) => {
                                handleActive(e, "Cases");
                            }}
                            routerLink={
                                <Link
                                    onClick={props.menuClick}
                                    to="/rm-lead/approved-cases"
                                />
                            }
                        >
                            Approved
                        </MenuItem>
                        <MenuItem
                            onClick={(e) => {
                                handleActive(e, "Cases");
                            }}
                            routerLink={
                                <Link
                                    onClick={props.menuClick}
                                    to="/rm-lead/draft-cases"
                                />
                            }
                        >
                            Draft
                        </MenuItem>
                        <MenuItem
                            onClick={(e) => {
                                handleActive(e, "Cases");
                            }}
                            routerLink={
                                <Link
                                    onClick={props.menuClick}
                                    to="/rm-lead/completed-cases"
                                />
                            }
                        >
                            Completed
                        </MenuItem>
                    </SubMenu>

                    <MenuItem
                        onClick={(e) => {
                            handleActive(e, "Reports");
                            setDropdown(null);
                        }}
                        routerLink={
                            <Link
                                onClick={props.menuClick}
                                to="/rm-lead/report"
                            />
                        }
                    >
                        <img src={report} alt="Form Template" /> Reports
                    </MenuItem>
                    <MenuItem
                        onClick={(e) => {
                            handleActive(e, "Entities");
                            setDropdown(null);
                        }}
                        routerLink={
                            <Link
                                onClick={props.menuClick}
                                to="/rm-lead/entities"
                            />
                        }
                    >
                        <img src={entity} alt="Entities" /> Entities
                    </MenuItem>
                    <MenuItem
                        onClick={(e) => {
                            handleActive(e, "Scheduler");
                            setDropdown(null);
                        }}
                        routerLink={
                            <Link onClick={props.menuClick} to="/schedule" />
                        }
                    >
                        <img src={schedule} alt="Form Template" />
                        Scheduler
                    </MenuItem>
                    {/* <MenuItem
                        onClick={(e) => {
                            handleActive(e, "Notification");
                            setDropdown(null);
                        }}
                        routerLink={
                            <Link
                                onClick={props.menuClick}
                                to="/notification"
                            />
                        }
                    >
                        <img src={bell} alt="Form Template" />
                        Notification
                    </MenuItem> */}
                    <MenuItem
                        onClick={(e) => {
                            handleActive(e, "Activity Logs");
                            setDropdown(null);
                        }}
                        routerLink={
                            <Link
                                onClick={props.menuClick}
                                to="/activity-log"
                            />
                        }
                    >
                        <img src={activityLog} alt="Form Template" />
                        Activity Logs
                    </MenuItem>
                    <MenuItem
                        onClick={(e) => {
                            handleActive(e, "PDPA");
                            setDropdown(null);
                        }}
                        routerLink={
                            <Link
                                onClick={props.menuClick}
                                to="/announcements-list"
                            />
                        }
                    >
                        <img src={announcement} alt="Form Template" />
                        PDPA
                    </MenuItem>
                    <MenuItem
                        onClick={(e) => {
                            handleActive(e, "Product");
                            setDropdown(null);
                        }}
                        routerLink={
                            <Link
                                onClick={props.menuClick}
                                to="/product-list"
                            />
                        }
                    >
                        <img src={productList} alt="Form Template" />
                        Product
                    </MenuItem>
                    <MenuItem
                        onClick={(e) => {
                            handleActive(e, getFolderName());
                        }}
                        routerLink={
                            <Link
                                onClick={props.menuClick}
                                to="/folder-structure"
                            />
                        }
                    >
                        <img src={folderIcon} alt="Folder" />
                        {getFolderName()}
                    </MenuItem>
                </Menu>
            </Sidebar>
        </ProSidebarProvider>
    );
}
